import { render, staticRenderFns } from "./CardsItem.vue?vue&type=template&id=f9e93960&lang=pug&"
import script from "./CardsItem.vue?vue&type=script&lang=js&"
export * from "./CardsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports